module.exports = __webpack_public_path__ + "static/ohio-flag-sticker-ce07e6d598e474bf95ac2d02d1083335.webp";